import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import PagesHeroSection from '../../../components/pagesHeroSection/pagesHeroSection';
// import ServiceMenu from '../../../components/serviceMenu';
import SEOUpdater from '../../../utils/hoc/SEOUpdater';

// import { emigrationServices } from './mock';
import './immigrationPage.scss';
import { Col, Row } from 'react-bootstrap';

const ImmigrationPage = () => {
  const { t } = useTranslation('immigration');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="services-page">
      <SEOUpdater page="immigration" />
      <PagesHeroSection page={t('pageTitle')} />

      <div className="services-section text-center">
        <div className="container">
          <h2 className="section-title">{t('heroTitle')}</h2>
          <p>
            <Trans i18nKey="intro.p1" t={t} components={{ 1: <b /> }} />
          </p>
          <p>
            <Trans i18nKey="intro.p2" t={t} components={{ 1: <b /> }} />
          </p>
          <div className="underline mx-auto mb-4"></div>
        </div>
      </div>

      <div className="services-content">
        <div className="container">
          <Row>
            <Col md={6}>
              <h3>{t('employment.title')}</h3>
              <p>{t('employment.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('family.title')}</h3>
              <p>{t('family.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('e2.title')}</h3>
              <p>{t('e2.desc1')}</p>
              <p>{t('e2.desc2')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('citizenship.title')}</h3>
              <p>{t('citizenship.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('extraordinary.title')}</h3>
              <p>{t('extraordinary.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('asylum.title')}</h3>
              <p>{t('asylum.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('uAndT.title')}</h3>
              <p>{t('uAndT.desc')}</p>
            </Col>

            <Col md={6}>
              <h3>{t('vawa.title')}</h3>
              <p>{t('vawa.desc')}</p>
            </Col>
          </Row>

          <div className="section-footer pt-5">
            <p className="text-center">{t('footer.p1')}</p>
            <p className="text-center">
              <Trans i18nKey="footer.p2" t={t} components={{ 1: <b /> }} />
            </p>
          </div>

          {/* Example ServiceMenu - Uncomment when ready
          <ServiceMenu
            list={emigrationServices.map(item => ({
              ...item,
              title: t(item.title),
            }))}
            title={t('pageTitle')}
          />
          */}
        </div>
      </div>
    </div>
  );
};

export default ImmigrationPage;
